import controller from './admin-oo.controller';
import template from './admin-oo.html';
import './admin-oo.scss';

export default {
	controller,
	controllerAs: '$ctrl',
	path:         '/admin/oo/:kid?/:tab?/:tab2?/:tab3?',
	reloadOnUrl:  false,
	template,
	title:        'menu.admin-oo',
};
